import { gql } from 'graphql-request'

export const clientsQuery = gql`
  query Clients($search: String, $cursor: String, $pageSize: Float, $siteId: String) {
    clients(search: $search, cursor: $cursor, pageSize: $pageSize, siteId: $siteId) {
      pageInfo {
        endCursor
        hasNextPage
        totalRecords
      }
      results {
        row {
          id
          email
          firstName
          lastName
          barcode
          siteInformation {
            siteId
            lastCheckInOn
          }
          profile
        }
        cursor
      }
    }
  }
`

export const clientQuery = gql`
  query Client($clientId: String!, $siteId: String) {
    client(id: $clientId, siteId: $siteId) {
      client {
        profileImage(input: { type: thumbnail, format: webp }) {
          url
        }
        dateOfBirth
        firstName
        lastName
        id
        email
      }
    }
  }
`

export const equipmentAssignmentsByClientIdQuery = gql`
  query EquipmentAssignmentsByClientId(
    $clientId: String!
    $siteId: String!
    $last: Boolean
    $status: [EquipmentAssignmentStatus!]
  ) {
    equipmentAssignmentsByClientId(
      clientId: $clientId
      siteId: $siteId
      last: $last
      status: $status
    ) {
      id
      checkInId
      delayMinutes
      timerMinutes
      status
      assignedAt
      doneAt
      cancelledAt
      createdAt
      updatedAt
    }
  }
`
